import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";

import CustomizerReducer from "./customizer/CustomizerSlice";
import UserProfileReducer from "./apps/userData/UserDataSlice";
import MeetingReducer from "./apps/meetings/MeetingDataSlice";
import AvailabilityReducer from "./apps/availability/AvailabilityDataSlice";
import portfolioReducer from "./apps/portfolio/PortfolioDataSlice";
import LoadingReducer from "./loading/LoadingSlice";
import NotificationReducer from "./apps/notifier/notifierDataSlice";
import AdminMeetingReducer from "./apps/adminMeetings/adminMeetingSlice";
import AdminModerationReducer from "./apps/adminModeration/adminModerationSlice";
import calendarIntegrationReducer from "./apps/availability/CalendarIntegrationSlice";

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window !== "undefined"
    ? createWebStorage("local")
    : createNoopStorage();

const persistConfig = {
  key: "root",
  storage,
};

const persistedCustomizerReducer = persistReducer(
  persistConfig,
  CustomizerReducer
);

export const store = configureStore({
  reducer: {
    user: UserProfileReducer,
    customizer: persistedCustomizerReducer,
    meetings: MeetingReducer,
    availability: AvailabilityReducer,
    portfolio: portfolioReducer,
    loading: LoadingReducer,
    notifications: NotificationReducer,
    adminMeetings: AdminMeetingReducer,
    adminModeration: AdminModerationReducer,
    calendarIntegration: calendarIntegrationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
